var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Pane'),_c('a-card',{staticClass:"container"},[_c('AddInfo')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }